import Vue from "vue";
import Router from "vue-router";
import AuthService from "../service/AuthService";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const DefaultContainerClient = () =>
  import("@/containers/DefaultContainerClient");

// Views - admin
const AdminHome = () => import("@/views/admin/Home/Home");

// const AdminUserList = () => import('@/views/admin/User/UserList');
// const AdminUserForm = () => import('@/views/admin/User/UserForm');

const AdminHssk4210List = () => import("@/views/admin/Hssk4210/Hssk4210List");
const AdminHsskHL7List = () => import("@/views/admin/HsskHL7/HsskHL7List");
const AdminHssk831Detail = () => import("@/views/admin/Hssk831/Hssk831Detail");
const AdminHssk831Update = () => import("@/views/admin/Hssk831/Hssk831Update");

const AdminPhienBanList = () => import("@/views/admin/PhienBan/PhienBanList");
const AdminPhienBanForm = () => import("@/views/admin/PhienBan/PhienBanForm");
const AdminCapNhatFilePDF = () => import("@/views/admin/CapNhatFilePDF/CapNhatFilePDFForm");

const AdminKhaiBaoDichList = () =>
  import("@/views/admin/KhaiBaoDich/KhaiBaoDichList");
// const AdminKhaiBaoDichForm = () => import('@/views/admin/KhaiBaoDich/KhaiBaoDichForm');

const AdminDangKyKhamList = () =>
  import("@/views/admin/DangKyKham/DangKyKhamList");
const AdminDangKyKhamForm = () =>
  import("@/views/admin/DangKyKham/DangKyKhamForm");
const AdminDangKyKhamFormS2 = () =>
  import("@/views/admin/DangKyKham/DangKyKhamFormS2");
const AdminDangKyKhamFormS3 = () =>
  import("@/views/admin/DangKyKham/DangKyKhamFormS3");
const AdminDangKyKhamFormS4 = () =>
  import("@/views/admin/DangKyKham/DangKyKhamFormS4");
const AdminDangKyKhamFormS5 = () =>
  import("@/views/admin/DangKyKham/DangKyKhamFormS5");

const AdminKhamDichList = () => import("@/views/admin/KhamDich/KhamDichList");
const AdminKhamDichForm = () => import("@/views/admin/KhamDich/KhamDichForm");

const AdminDoiTuongTheoDoiList = () =>
  import("@/views/admin/DoiTuongTheoDoi/DoiTuongTheoDoiList");
const AdminDoiTuongTheoDoiForm = () =>
  import("@/views/admin/DoiTuongTheoDoi/DoiTuongTheoDoiForm");
const AdminDoiTuongTheoDoiBaoCao = () =>
  import("@/views/admin/DoiTuongTheoDoi/DoiTuongTheoDoiBaoCao");

const AdminBieuMauTongHop2AList = () =>
  import("@/views/admin/BieuMauTongHop/BieuMauTongHop2AList");
const AdminBieuMauTongHop2BList = () =>
  import("@/views/admin/BieuMauTongHop/BieuMauTongHop2BList");
const AdminBieuMauTongHopForm = () =>
  import("@/views/admin/BieuMauTongHop/BieuMauTongHopForm");

const AdminHsskBNList = () => import('@/views/admin/HsskBN/HsskBNList');
const AdminHsskBNForm = () => import('@/views/admin/HsskBN/HsskBNUpdate');
const AdminHsskBNFormSK = () => import('@/views/admin/HsskBN/HsskBNUpdateSK');

const AdminDanhMucTinTucList = () =>
  import("@/views/admin/DanhMucTinTuc/DanhMucTinTucList");
const AdminDanhMucTinTucForm = () =>
  import("@/views/admin/DanhMucTinTuc/DanhMucTinTucForm");

const AdminTinTucList = () => import("@/views/admin/TinTuc/TinTucList");
const AdminTinTucForm = () => import("@/views/admin/TinTuc/TinTucForm");

const AdminQuanTriMenuApp = () =>
  import("@/views/admin/QuanTriMenuApp/QuanTriMenuApp");
const AdminChatRoomList = () => import("@/views/admin/ChatRoom/ListRoom");
const AdminChatRoomForm = () => import("@/views/admin/ChatRoom/ChatRoomForm");

const AdminQATypesForm = () => import("@/views/admin/QATypes/QATypesForm");
const AdminQATypesList = () => import("@/views/admin/QATypes/QATypesList");

const AdminSucKhoeCaNhanList = () => import("@/views/admin/SucKhoeCaNhan/SucKhoeCaNhanList");
const AdminSucKhoeCaNhanForm = () => import("@/views/admin/SucKhoeCaNhan/SucKhoeCaNhanDetail");

const AdminBacSi = () => import("@/views/admin/BacSiVien/BacSiVienList");
const AdminBacSiImport = () => import("@/views/admin/BacSiVien/BacSiVienImport");

const AdminAppList = () => import("@/views/admin/App/AppList");
const AdminAppForm = () => import("@/views/admin/App/AppForm");

const AdminAppConfigList = () => import("@/views/admin/AppConfig/AppConfigList");
const AdminAppConfigForm = () => import("@/views/admin/AppConfig/AppConfigForm");

const AdminTiemChung = () => import("@/views/admin/TiemChung/TiemChung");

// Đăng ký cấu hình giá
const AdminCauHinhDangKyKhamList = () => import("@/views/admin/CauHinhDangKyKham/CauHinhDangKyKhamList");
const AdminCauHinhDangKyKhamForm = () => import("@/views/admin/CauHinhDangKyKham/CauHinhDangKyKhamForm");
const AdminCauHinhDangKyTuVanKhamList = () => import("@/views/admin/CauHinhDangKyTuVanKham/CauHinhDangKyTuVanKhamList");
const AdminCauHinhDangKyTuVanKhamForm = () => import("@/views/admin/CauHinhDangKyTuVanKham/CauHinhDangKyTuVanKhamForm");

// Views - auth
const AuthPage404 = () => import("@/views/auth/Page404");
const AuthLogin = () => import("@/views/auth/Login");
const AuthRegister = () => import("@/views/auth/Register");
const AuthChangePassword = () => import("@/views/auth/ChangePassword");
const AuthForgotPassword = () => import("@/views/auth/ForgotPassword");
const AuthResetPassword = () => import("@/views/auth/ResetPassword");

// Views - client
const ClientHome = () => import("@/views/client/Home");

Vue.use(Router);
/* Các quyền người dùng: BuiltinAdmin - Tài khoản super admin, Admin - Quản trị hệ thống, Officer - Quản lý nhà nước, TourGuide - Hướng dẫn viên du lịch, TourAgent - Công ty lữ hành, User - người dùng */
//ex roles: ["BuiltinAdmin ", "Admin", "Hospital", "Doctor", "Citizen", "User"]

const router = new Router({
  base: window.MyConfig.pathDefault,
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: "/",
      redirect: window.MyConfig.defaultRouter,
      component: DefaultContainerClient
    },
    // {
    //   path: '/home',
    //   name: 'Client-Home',
    //   component: ClientHome,
    //   meta: {
    //     allowAccess: ['*'],
    //     page: 'client'
    //   },
    // },
    {
      path: "/admin",
      redirect: "/admin/home",
      component: DefaultContainer,
      children: [
        {
          path: "home",
          name: "Admin-Home",
          component: AdminHome,
          meta: {
            allowAccess: ["*"],
            page: "admin"
          }
        },
        // {
        //   path: 'User',
        //   name: 'Admin-User',
        //   redirect: '/admin/User/list',
        //   component: {
        //     render(c) {
        //       return c('router-view')
        //     }
        //   },
        //   children: [{
        //     path: 'list',
        //     name: 'Admin-User-list',
        //     component: AdminUserList,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   {
        //     path: 'create',
        //     name: 'Admin-User-create',
        //     component: AdminUserForm,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   {
        //     path: 'update/:id',
        //     name: 'Admin-User-update',
        //     component: AdminUserForm,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   {
        //     path: 'detail/:id',
        //     name: 'Admin-User-detail',
        //     component: AdminUserForm,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   ]
        // },

        {
          path: "hssk4210",
          name: "Admin-hssk4210",
          component: AdminHssk4210List,
          meta: {
            allowAccess: ["*"],
            page: "admin"
          }
        },
        {
          path: "hsskHL7",
          name: "Admin-hsskHL7",
          component: AdminHsskHL7List,
          meta: {
            allowAccess: ["Hospital", "Doctor_His", "Citizen"],
            page: "admin"
          }
        },
        {
          path: "hssk831",
          name: "Admin-hssk831",
          redirect: "/admin/hssk831/detail",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "detail",
              name: "Admin-hssk831-detail",
              component: AdminHssk831Detail,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "update",
              name: "Admin-hssk831-update",
              component: AdminHssk831Update,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "details",
              name: "Admin-hssk831-details",
              component: AdminHssk831Detail,
              meta: {
                allowAccess: ["Doctor_His", "Hospital"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "PhienBan",
          name: "Admin-PhienBan",
          redirect: "/admin/PhienBan/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-PhienBan-list",
              component: AdminPhienBanList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-PhienBan-create",
              component: AdminPhienBanForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-PhienBan-update",
              component: AdminPhienBanForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-PhienBan-detail",
              component: AdminPhienBanForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: 'CapNhatFilePDF',
          name: 'Admin-CapNhatFilePDF',
          redirect: '/admin/CapNhatFilePDF/list',
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CapNhatFilePDF-list",
              component: AdminCapNhatFilePDF,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },

          ]
        },
        {
          path: "KhaiBaoDich",
          name: "Admin-KhaiBaoDich",
          redirect: "/admin/KhaiBaoDich/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-KhaiBaoDich-list",
              component: AdminKhaiBaoDichList,
              meta: {
                allowAccess: ["Citizen", "tichhop"],
                page: "admin"
              }
            }
            /* {
            path: 'create',
            name: 'Admin-KhaiBaoDich-create',
            component: AdminKhaiBaoDichForm,
            meta: {
              allowAccess: ['*'],
              page: 'admin'
            },
          },
          {
            path: 'update/:id',
            name: 'Admin-KhaiBaoDich-update',
            component: AdminKhaiBaoDichForm,
            meta: {
              allowAccess: ['*'],
              page: 'admin'
            },
          },
          {
            path: 'detail/:id',
            name: 'Admin-KhaiBaoDich-detail',
            component: AdminKhaiBaoDichForm,
            meta: {
              allowAccess: ['*'],
              page: 'admin'
            },
          }, */
          ]
        },
        {
          path: "DangKyKham",
          name: "Admin-DangKyKham",
          redirect: "/admin/DangKyKham/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DangKyKham-list",
              component: AdminDangKyKhamList,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DangKyKham-create",
              component: AdminDangKyKhamForm,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "createStep2",
              name: "Admin-DangKyKham-createStep2",
              component: AdminDangKyKhamFormS2,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "createStep3",
              name: "Admin-DangKyKham-createStep3",
              component: AdminDangKyKhamFormS3,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "createStep4",
              name: "Admin-DangKyKham-createStep4",
              component: AdminDangKyKhamFormS4,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            },
            {
              path: "createStep5",
              name: "Admin-DangKyKham-createStep5",
              component: AdminDangKyKhamFormS5,
              meta: {
                allowAccess: ["Citizen"],
                page: "admin"
              }
            }
            // {
            //   path: 'detail/:id',
            //   name: 'Admin-DangKyKham-createStep3',
            //   component: AdminDangKyKhamForm,
            //   meta: {
            //     allowAccess: ['Citizen'],
            //     page: 'admin'
            //   },
            // },
          ]
        },
        {
          path: "KhamDich",
          name: "Admin-KhamDich",
          redirect: "/admin/KhamDich/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-KhamDich-list",
              component: AdminKhamDichList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-KhamDich-create",
              component: AdminKhamDichForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-KhamDich-update",
              component: AdminKhamDichForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-KhamDich-detail",
              component: AdminKhamDichForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "HsskBN",
          name: "Admin-HsskBN",
          redirect: "/admin/HsskBN/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-HsskBN-list",
              component: AdminHsskBNList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-HsskBN-create",
              component: AdminHsskBNForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-HsskBN-update",
              component: AdminHsskBNForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
            // {
            //   path: 'detail/:id',
            //   name: 'Admin-HsskBN-detail',
            //   component: AdminHsskBNForm,
            //   meta: {
            //     allowAccess: ['*'],
            //     page: 'admin'
            //   },
            // },
            // {
            //   path: 'baocao/:id',
            //   name: 'Admin-HsskBN-baocao',
            //   component: AdminHsskBNBaoCao,
            //   meta: {
            //     allowAccess: ['*'],
            //     page: 'admin'
            //   },
            // },
          ]
        },
        {
          path: "DoiTuongTheoDoi",
          name: "Admin-DoiTuongTheoDoi",
          redirect: "/admin/DoiTuongTheoDoi/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DoiTuongTheoDoi-list",
              component: AdminDoiTuongTheoDoiList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DoiTuongTheoDoi-create",
              component: AdminDoiTuongTheoDoiForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DoiTuongTheoDoi-update",
              component: AdminDoiTuongTheoDoiForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DoiTuongTheoDoi-detail",
              component: AdminDoiTuongTheoDoiForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "baocao/:id",
              name: "Admin-DoiTuongTheoDoi-baocao",
              component: AdminDoiTuongTheoDoiBaoCao,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "BieuMauTongHop2A",
          name: "Admin-BieuMauTongHop2A",
          redirect: "/admin/BieuMauTongHop2A/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-BieuMauTongHop2A-list",
              component: AdminBieuMauTongHop2AList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "BieuMauTongHop2B",
          name: "Admin-BieuMauTongHop2B",
          redirect: "/admin/BieuMauTongHop2B/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-BieuMauTongHop2B-list",
              component: AdminBieuMauTongHop2BList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMucTinTuc",
          name: "Admin-DanhMucTinTuc",
          redirect: "/admin/DanhMucTinTuc/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhMucTinTuc-list",
              component: AdminDanhMucTinTucList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhMucTinTuc-create",
              component: AdminDanhMucTinTucForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhMucTinTuc-update",
              component: AdminDanhMucTinTucForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhMucTinTuc-detail",
              component: AdminDanhMucTinTucForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "TinTuc",
          name: "Admin-TinTuc",
          redirect: "/admin/TinTuc/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-TinTuc-list",
              component: AdminTinTucList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-TinTuc-create",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-TinTuc-update",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-TinTuc-detail",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "App",
          name: "Admin-App",
          redirect: "/admin/App/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-App-list",
              component: AdminAppList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-App-create",
              component: AdminAppForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-App-update",
              component: AdminAppForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-App-detail",
              component: AdminAppForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "AppConfig",
          name: "Admin-AppConfig",
          redirect: "/admin/AppConfig/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-AppConfig-list",
              component: AdminAppConfigList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create/:id",
              name: "Admin-AppConfig-create",
              component: AdminAppConfigForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-AppConfig-update",
              component: AdminAppConfigForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-AppConfig-detail",
              component: AdminAppConfigForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: 'create-step-2/:id',
          name: 'Admin-HsskBN-create-sk',
          component: AdminHsskBNFormSK,
          meta: {
            allowAccess: ['*'],
            page: 'admin'
          },
        },
        {
          path: 'update/:id',
          name: 'Admin-HsskBN-update',
          component: AdminHsskBNForm,
          meta: {
            allowAccess: ['*'],
            page: 'admin'
          },
        },
        {
          path: 'update-health-infor/:id',
          name: 'Admin-HsskBN-update-sk',
          component: AdminHsskBNFormSK,
          meta: {
            allowAccess: ['*'],
            page: 'admin'
          },
        },
        // {
        //   path: 'detail/:id',
        //   name: 'Admin-HsskBN-detail',
        //   component: AdminHsskBNForm,
        //   meta: {
        //     allowAccess: ['*'],
        //     page: 'admin'
        //   },
        // },
        // {
        //   path: 'baocao/:id',
        //   name: 'Admin-HsskBN-baocao',
        //   component: AdminHsskBNBaoCao,
        //   meta: {
        //     allowAccess: ['*'],
        //     page: 'admin'
        //   },
        // },
        {
          path: 'DoiTuongTheoDoi',
          name: 'Admin-DoiTuongTheoDoi',
          redirect: '/admin/DoiTuongTheoDoi/list',
          component: {
            render(c) {
              return c('router-view')
            }
          }
        },
        {
          path: "ChatRoom",
          name: "Admin-ChatRoom",
          redirect: "/admin/ChatRoom/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-ChatRoom-list",
              component: AdminChatRoomList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-ChatRoom-create",
              component: AdminChatRoomForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-ChatRoom-detail",
              component: AdminChatRoomForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-ChatRoom-update",
              component: AdminChatRoomForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "BacSi",
          name: "Admin-BacSi",
          redirect: "/admin/BacSi/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-BacSi-list",
              component: AdminBacSi,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "import",
              name: "Admin-BacSi-import",
              component: AdminBacSiImport,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "SucKhoeCaNhan",
          name: "Admin-SucKhoeCaNhan",
          redirect: "/admin/SucKhoeCaNhan/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-SucKhoeCaNhan-list",
              component: AdminSucKhoeCaNhanList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-SucKhoeCaNhan-create",
              component: AdminSucKhoeCaNhanForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-SucKhoeCaNhan-detail",
              component: AdminSucKhoeCaNhanForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-SucKhoeCaNhan-update",
              component: AdminSucKhoeCaNhanForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "QATypes",
          name: "Admin-QATypes",
          redirect: "/admin/QATypes/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-QATypes-list",
              component: AdminQATypesList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-QATypes-create",
              component: AdminQATypesForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-QATypes-detail",
              component: AdminQATypesForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-QATypes-update",
              component: AdminQATypesForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "ChungNhanTiemChung",
          name: "Admin-TiemChung",
          component: AdminTiemChung,
          meta: {
            allowAccess: ['Citizen'],
            page: "admin"
          }
        },
        {
          path: "CauHinhDangKyKham",
          name: "Admin-CauHinhDangKyKham",
          redirect: "/admin/CauHinhDangKyKham/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CauHinhDangKyKham-list",
              component: AdminCauHinhDangKyKhamList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-CauHinhDangKyKham-create",
              component: AdminCauHinhDangKyKhamForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-CauHinhDangKyKham-detail",
              component: AdminCauHinhDangKyKhamForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-CauHinhDangKyKham-update",
              component: AdminCauHinhDangKyKhamForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "CauHinhDangKyTuVanKham",
          name: "Admin-CauHinhDangKyTuVanKham",
          redirect: "/admin/CauHinhDangKyTuVanKham/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CauHinhDangKyTuVanKham-list",
              component: AdminCauHinhDangKyTuVanKhamList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-CauHinhDangKyTuVanKham-create",
              component: AdminCauHinhDangKyTuVanKhamForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-CauHinhDangKyTuVanKham-detail",
              component: AdminCauHinhDangKyTuVanKhamForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-CauHinhDangKyTuVanKham-update",
              component: AdminCauHinhDangKyTuVanKhamForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
      ]
    },

    {
      path: "/auth",
      redirect: "/auth/login",
      name: "Auth",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Auth-Page404",
          component: AuthPage404,
          meta: {
            page: "auth"
          }
        },
        {
          path: "login",
          name: "Auth-Login",
          component: AuthLogin,
          meta: {
            page: "auth"
          }
        },
        {
          path: "register",
          name: "Auth-Register",
          component: AuthRegister,
          meta: {
            page: "auth"
          }
        },
        {
          path: "changepassword",
          name: "Auth-ChangePassword",
          component: AuthChangePassword,
          meta: {
            page: "auth"
          }
        },
        {
          path: "forgotPassword",
          name: "Auth-ForgotPassword",
          component: AuthForgotPassword,
          meta: {
            page: "auth"
          }
        },
        {
          path: "resetPassword",
          name: "Auth-ResetPassword",
          component: AuthResetPassword,
          meta: {
            page: "auth"
          }
        }
      ]
    }
  ]
});
export default router;

//check route
router.beforeEach(function (to, from, next) {
  if (from.name != to.name) {
    if (to.meta.page && to.meta.page == "admin" && to.name == "Admin-hssk4210") {
      next();
      return;
    }
    else if (to.meta.page && to.meta.page == "admin") {
      let dataRouter = {
        name: to.name,
        query: to.query
      };
      let routerHistory = JSON.stringify(dataRouter);
      window.localStorage.setItem("routerHistory", routerHistory);
      AuthService.me()
        .then(res => {
          if (res.result && res.result.account == "tichhop") {
            res.result.roles = ["tichhop"];
          }
          window.localStorage.setItem(
            "currentUser",
            JSON.stringify(res.result)
          );
          if (to.meta.allowAccess && to.meta.allowAccess.indexOf("*") == 0) {
            next();
          } else {
            if (res.result && res.result.roles && res.result.roles.length > 0) {
              var access = false;
              res.result.roles.forEach(item => {
                if (
                  to.meta.allowAccess &&
                  to.meta.allowAccess.indexOf(item) != -1
                ) {
                  access = true;
                }
              });
              if (access) {
                next();
              } else {
                if (
                  to.name &&
                  to.name == "Admin-hssk831-details" &&
                  from.name &&
                  from.name == "Auth-Login"
                ) {
                  if (to.name && to.name == "Admin-hssk831-details") {
                    AuthService.logout(false)
                      .then(res => {
                        window.localStorage.removeItem("routerHistory");
                        window.localStorage.removeItem("token");
                        window.localStorage.removeItem("account");
                        window.localStorage.removeItem("dataUser");
                        window.localStorage.removeItem("cardcode");
                        window.localStorage.removeItem("currentUser");
                        window.sessionStorage.removeItem("steps");
                        window.sessionStorage.removeItem("lastBooking");
                        window.localStorage.removeItem("dataLocalHealthRecord");
                        window.localStorage.removeItem("isDoctorTram");
                        window.localStorage.removeItem("currentUserBS");
                        window.location.href = to.path;
                      })
                      .catch(error => { });
                  }
                }
                toastr.warning("Không có quyền truy cập trang này");
              }
            }
          }
        })
        .catch(error => {
          window.localStorage.removeItem("routerHistory");
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("account");
          window.localStorage.removeItem("dataUser");
          window.localStorage.removeItem("cardcode");
          window.sessionStorage.removeItem("steps");
          window.localStorage.removeItem("dataLocalHealthRecord");
          next("/auth/login");
        });
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
    } else {
      next("/auth/404");
    }
  } else {
    if (!to.name) {
      next("/auth/404");
    } else {
      next();
    }
  }
});
